<template>
  <v-container
    fluid
    v-touch="{
      right: () => swipe(),
    }"
    class="position-relative"
  >
    <v-alert
      v-if="isUrlCopy && !$store.state.isMobile"
      v-model="isUrlCopy"
      closable
      rounded="xl"
      variant="tonal"
      :text="`Ссылка на письмо скопирована`"
      color="blue-lighten-1"
      style="margin-bottom: 20px"
      max-height="100"
    ></v-alert>

    <template class="task__add d-flex" align="center">
      <v-dialog
        v-model="taskDialog"
        :fullscreen="$store.state.isMobile"
        width="500"
      >
        <v-card
          :class="$store.state.isMobile ? 'pa-4' : 'pa-12'"
          :width="!$store.state.isMobile ? 350 : ''"
          :rounded="$store.state.isMobile ? '' : 'xl'"
          height="600"
          v-touch="{
            right: () => (taskDialog = !taskDialog),
          }"
        >
          <v-card-actions class="ma-0 pa-0 mb-4 justify-start">
            <v-btn
              v-if="$store.state.isMobile"
              variant="text"
              class="ma-2"
              density="compact"
              icon="mdi-chevron-left"
              @click="taskDialog = !taskDialog"
            >
            </v-btn>

            <v-card-title> Создать задачу</v-card-title>
          </v-card-actions>
          <v-card-text class="ma-0 pa-0">
            <v-autocomplete
              :items="[]"
              label="Ответственный"
              variant="outlined"
              rounded="xl"
            ></v-autocomplete>

            <v-date-input
              prepend-icon=""
              append-inner-icon="$calendar"
              label="Срок выполнения"
              variant="outlined"
              rounded="xl"
            ></v-date-input>
          </v-card-text>

          <v-card-actions class="ma-0 pa-0">
            <v-spacer></v-spacer>

            <v-btn
              color="blue-lighten-1"
              text="Создать"
              variant="flat"
              size="large"
              block
              rounded="xl"
              @click="taskDialog = false"
            ></v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <v-row class="actions align-center" justify="space-between">
      <v-col class="back-arrow" cols="auto">
        <v-btn
          variant="text"
          class="ma-0"
          density="compact"
          icon="mdi-chevron-left"
          @click="this.$emit('update:modal', false)"
        >
        </v-btn>
      </v-col>
      <!--<v-col class="task-add" cols="auto" v-if="$store.state.isMobile">
        <v-btn
          :color="item.favorite ? 'yellow' : 'black'"
          :icon="item.favorite ? 'mdi-star' : 'mdi-star-outline'"
          @click="this.$emit('update:favorite', !item.favorite)"
          variant="text"
        >
        </v-btn>
      </v-col>-->
    </v-row>
    <v-row
      v-if="!$store.state.isMobile"
      class="actions d-flex justify-space-between aling-center"
    >
      <v-col cols="auto" class="d-flex justify-space-between">
        <v-btn
          variant="text"
          class="mr-4"
          rounded="xl"
          @click="
            $emit('update:newMail', false);
            $emit('update:fwd', false);
            $emit('update:sendModal', true);
          "
        >
          <v-icon class="mr-2"
            ><svg
              width="18"
              height="15"
              viewBox="0 0 18 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.90625 14.625C7.69271 14.625 7.49479 14.5807 7.3125 14.4922C7.13542 14.4089 6.94531 14.2708 6.74219 14.0781L0.554688 8.26562C0.398438 8.125 0.289062 7.97396 0.226562 7.8125C0.164062 7.65104 0.132812 7.5 0.132812 7.35938C0.132812 7.21354 0.164062 7.0625 0.226562 6.90625C0.289062 6.74479 0.398438 6.59375 0.554688 6.45312L6.74219 0.6875C6.96615 0.473958 7.16146 0.322917 7.32812 0.234375C7.49479 0.140625 7.68229 0.09375 7.89062 0.09375C8.20312 0.09375 8.45833 0.200521 8.65625 0.414062C8.85417 0.622396 8.95312 0.875 8.95312 1.17188V3.96875H9.14844C10.5026 3.96875 11.6771 4.17969 12.6719 4.60156C13.6667 5.01823 14.487 5.625 15.1328 6.42188C15.7839 7.21875 16.2682 8.18229 16.5859 9.3125C16.9036 10.4375 17.0625 11.7083 17.0625 13.125C17.0625 13.6094 16.9688 13.974 16.7812 14.2188C16.599 14.4688 16.3724 14.5938 16.1016 14.5938C15.8984 14.5938 15.7031 14.5495 15.5156 14.4609C15.3333 14.3724 15.1641 14.1875 15.0078 13.9062C14.5964 13.1354 14.1172 12.5208 13.5703 12.0625C13.0286 11.6042 12.3958 11.2734 11.6719 11.0703C10.9479 10.8672 10.1068 10.7656 9.14844 10.7656H8.95312V13.5859C8.95312 13.8828 8.85417 14.1302 8.65625 14.3281C8.45833 14.526 8.20833 14.625 7.90625 14.625Z"
                fill="#A1A7B0"
              />
            </svg>
          </v-icon>

          <span>Ответить</span>
        </v-btn>

        <v-btn
          class="mr-4"
          variant="text"
          rounded="xl"
          @click="
            $emit('update:newMail', false);
            $emit('update:fwd', true);
            $emit('update:sendModal', true);
          "
        >
          <v-icon class="mr-2"
            ><svg
              width="18"
              height="15"
              viewBox="0 0 18 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.0156 14.625C10.2188 14.625 10.4115 14.5807 10.5938 14.4922C10.7812 14.4089 10.9766 14.2708 11.1797 14.0781L17.3672 8.26562C17.5182 8.125 17.625 7.97396 17.6875 7.8125C17.7552 7.65104 17.7891 7.5 17.7891 7.35938C17.7891 7.21354 17.7552 7.0625 17.6875 6.90625C17.625 6.74479 17.5182 6.59375 17.3672 6.45312L11.1797 0.6875C10.9557 0.473958 10.7578 0.322917 10.5859 0.234375C10.4193 0.140625 10.2318 0.09375 10.0234 0.09375C9.71615 0.09375 9.46094 0.200521 9.25781 0.414062C9.0599 0.622396 8.96094 0.875 8.96094 1.17188V3.96875H8.76562C7.41146 3.96875 6.23698 4.17969 5.24219 4.60156C4.2526 5.01823 3.43229 5.625 2.78125 6.42188C2.13542 7.21875 1.65365 8.18229 1.33594 9.3125C1.01823 10.4375 0.859375 11.7083 0.859375 13.125C0.859375 13.6094 0.950521 13.974 1.13281 14.2188C1.32031 14.4688 1.54948 14.5938 1.82031 14.5938C2.02344 14.5938 2.21615 14.5495 2.39844 14.4609C2.58594 14.3724 2.75521 14.1875 2.90625 13.9062C3.31771 13.1354 3.79688 12.5208 4.34375 12.0625C4.89062 11.6042 5.52604 11.2734 6.25 11.0703C6.97396 10.8672 7.8125 10.7656 8.76562 10.7656H8.96094V13.5859C8.96094 13.8828 9.0599 14.1302 9.25781 14.3281C9.46094 14.526 9.71354 14.625 10.0156 14.625Z"
                fill="#A1A7B0"
              />
            </svg>
          </v-icon>

          <span>Переслать</span>
        </v-btn>

        <v-btn
          rounded="xl"
          value="nearby"
          @click="taskDialog = !taskDialog"
          class="mr-4"
          variant="text"
        >
          <v-icon class="mr-2"
            ><svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5 2.5C4.33696 2.5 3.70107 2.76339 3.23223 3.23223C2.76339 3.70107 2.5 4.33696 2.5 5V15C2.5 15.663 2.76339 16.2989 3.23223 16.7678C3.70107 17.2366 4.33696 17.5 5 17.5H15C15.663 17.5 16.2989 17.2366 16.7678 16.7678C17.2366 16.2989 17.5 15.663 17.5 15V5C17.5 4.33696 17.2366 3.70107 16.7678 3.23223C16.2989 2.76339 15.663 2.5 15 2.5H5ZM8.33333 6.66667C8.33333 6.44565 8.42113 6.23369 8.57741 6.07741C8.73369 5.92113 8.94565 5.83333 9.16667 5.83333H14.1667C14.3877 5.83333 14.5996 5.92113 14.7559 6.07741C14.9122 6.23369 15 6.44565 15 6.66667C15 6.88768 14.9122 7.09964 14.7559 7.25592C14.5996 7.4122 14.3877 7.5 14.1667 7.5H9.16667C8.94565 7.5 8.73369 7.4122 8.57741 7.25592C8.42113 7.09964 8.33333 6.88768 8.33333 6.66667ZM8.33333 10C8.33333 9.77899 8.42113 9.56702 8.57741 9.41074C8.73369 9.25446 8.94565 9.16667 9.16667 9.16667H14.1667C14.3877 9.16667 14.5996 9.25446 14.7559 9.41074C14.9122 9.56702 15 9.77899 15 10C15 10.221 14.9122 10.433 14.7559 10.5893C14.5996 10.7455 14.3877 10.8333 14.1667 10.8333H9.16667C8.94565 10.8333 8.73369 10.7455 8.57741 10.5893C8.42113 10.433 8.33333 10.221 8.33333 10ZM8.33333 13.3333C8.33333 13.1123 8.42113 12.9004 8.57741 12.7441C8.73369 12.5878 8.94565 12.5 9.16667 12.5H14.1667C14.3877 12.5 14.5996 12.5878 14.7559 12.7441C14.9122 12.9004 15 13.1123 15 13.3333C15 13.5543 14.9122 13.7663 14.7559 13.9226C14.5996 14.0789 14.3877 14.1667 14.1667 14.1667H9.16667C8.94565 14.1667 8.73369 14.0789 8.57741 13.9226C8.42113 13.7663 8.33333 13.5543 8.33333 13.3333ZM5.83333 5.83333C5.61232 5.83333 5.40036 5.92113 5.24408 6.07741C5.0878 6.23369 5 6.44565 5 6.66667C5 6.88768 5.0878 7.09964 5.24408 7.25592C5.40036 7.4122 5.61232 7.5 5.83333 7.5C6.05435 7.5 6.26714 7.4122 6.42342 7.25592C6.5797 7.09964 6.6675 6.88768 6.6675 6.66667C6.6675 6.44565 6.5797 6.23369 6.42342 6.07741C6.26714 5.92113 6.05435 5.83333 5.83333 5.83333ZM5 10C5 9.77899 5.0878 9.56702 5.24408 9.41074C5.40036 9.25446 5.61232 9.16667 5.83333 9.16667C6.05435 9.16667 6.26714 9.25446 6.42342 9.41074C6.5797 9.56702 6.6675 9.77899 6.6675 10C6.6675 10.221 6.5797 10.433 6.42342 10.5893C6.26714 10.7455 6.05518 10.8333 5.83417 10.8333C5.61315 10.8333 5.40036 10.7455 5.24408 10.5893C5.0878 10.433 5 10.221 5 10ZM5.83333 12.5C5.61232 12.5 5.40036 12.5878 5.24408 12.7441C5.0878 12.9004 5 13.1123 5 13.3333C5 13.5543 5.0878 13.7663 5.24408 13.9226C5.40036 14.0789 5.61232 14.1667 5.83333 14.1667C6.05435 14.1667 6.26714 14.0789 6.42342 13.9226C6.5797 13.7663 6.6675 13.5543 6.6675 13.3333C6.6675 13.1123 6.5797 12.9004 6.42342 12.7441C6.26714 12.5878 6.05435 12.5 5.83333 12.5Z"
                fill="#A1A7B0"
              />
            </svg>
          </v-icon>

          <span>Создать задачу</span>
        </v-btn>
        <v-btn
          value="1"
          @click="getLink"
          class="mr-4"
          variant="text"
          rounded="xl"
        >
          <v-icon class="mr-2"
            ><svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.17245 14.829L14.8294 9.17196M7.05045 11.293L5.63645 12.707C5.265 13.0784 4.97036 13.5194 4.76933 14.0047C4.56831 14.49 4.46484 15.0102 4.46484 15.5355C4.46484 16.0608 4.56831 16.5809 4.76933 17.0662C4.97036 17.5515 5.265 17.9925 5.63645 18.364C6.00789 18.7354 6.44886 19.03 6.93417 19.2311C7.41949 19.4321 7.93965 19.5356 8.46495 19.5356C8.99025 19.5356 9.51041 19.4321 9.99572 19.2311C10.481 19.03 10.922 18.7354 11.2934 18.364L12.7054 16.95M11.2924 7.04996L12.7064 5.63596C13.0779 5.26451 13.5189 4.96987 14.0042 4.76885C14.4895 4.56782 15.0096 4.46436 15.5349 4.46436C16.0602 4.46436 16.5804 4.56782 17.0657 4.76885C17.551 4.96987 17.992 5.26451 18.3634 5.63596C18.7349 6.0074 19.0295 6.44837 19.2306 6.93369C19.4316 7.419 19.535 7.93916 19.535 8.46446C19.535 8.98976 19.4316 9.50992 19.2306 9.99523C19.0295 10.4805 18.7349 10.9215 18.3634 11.293L16.9494 12.707"
                stroke="#A1A7B0"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-icon>

          <span>Создать ссылку</span>
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <v-btn icon="mdi-delete" variant="text" @click="deleteMail"></v-btn>
        <!--<v-btn
          :color="item.favorite ? 'yellow' : 'black'"
          :icon="item.favorite ? 'mdi-star' : 'mdi-star-outline'"
          @click="this.$emit('update:favorite', !item.favorite)"
          variant="text"
        >
        </v-btn>-->
      </v-col>
    </v-row>
    <v-row class="title">
      <v-col cols="auto"
        ><h2>{{ item.subject }}</h2></v-col
      >
    </v-row>
    <v-row class="sender align-center mb-2">
      <v-col class="avatar mr-2" cols="auto">
        <v-avatar size="64" color="primary">
          <img width="64" v-if="item.icon" :src="item.icon" alt="Avatar" />
          <span v-else class="text-h6">U</span>
          <!-- Fallback -->
        </v-avatar>
      </v-col>
      <v-col class="sender-descr ma-0 pa-0">
        <div>
          <v-col cols="12" class="sender-name ma-0 pa-0">
            {{ item.fromName }}
          </v-col>
          <v-col cols="12" class="sender-mail ma-0 pa-0">
            {{ item.from }}
          </v-col>
          <v-col cols="12" class="date ma-0 pa-0">
            <v-list-item-subtitle>{{ item.dateTitle }}</v-list-item-subtitle>
          </v-col>
        </div>
      </v-col>
    </v-row>

    <v-expansion-panels class="mb-4" rounded="xl" v-if="item.files.length > 0">
      <v-expansion-panel title="Прикрепленные файлы">
        <v-expansion-panel-text>
          <v-row class="files mb-2 d-flex flex-column">
            <v-list :class="$store.state.isMobile ? '' : 'd-flex'">
              <v-list-item
                rounded="xl"
                v-for="file in item.files"
                :key="file"
                @click="fileDownload(file)"
              >
                <v-icon :icon="file.icon"></v-icon>
                {{ file.name }}
              </v-list-item>
            </v-list>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-row class="text-mail pa-2 align-center justify-start">
      <div style="width: 100%" v-html="item.body"></div>
    </v-row>

    <v-row
      style="left: 0px; bottom: 0; position: fixed; width: 100%"
      class="ma-0 align-center"
      v-if="$store.state.isMobile"
    >
      <v-card width="100%" class="d-flex justify-space-between align-center">
        <v-btn
          variant="text"
          size="small"
          class="mr-2"
          height="40"
          width="70"
          @click="
            $emit('update:newMail', false);
            $emit('update:fwd', false);
            $emit('update:sendModal', true);
          "
        >
          <v-row class="flex-column align-center">
            <v-icon class="mb-2"
              ><svg
                width="18"
                height="15"
                viewBox="0 0 18 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.90625 14.625C7.69271 14.625 7.49479 14.5807 7.3125 14.4922C7.13542 14.4089 6.94531 14.2708 6.74219 14.0781L0.554688 8.26562C0.398438 8.125 0.289062 7.97396 0.226562 7.8125C0.164062 7.65104 0.132812 7.5 0.132812 7.35938C0.132812 7.21354 0.164062 7.0625 0.226562 6.90625C0.289062 6.74479 0.398438 6.59375 0.554688 6.45312L6.74219 0.6875C6.96615 0.473958 7.16146 0.322917 7.32812 0.234375C7.49479 0.140625 7.68229 0.09375 7.89062 0.09375C8.20312 0.09375 8.45833 0.200521 8.65625 0.414062C8.85417 0.622396 8.95312 0.875 8.95312 1.17188V3.96875H9.14844C10.5026 3.96875 11.6771 4.17969 12.6719 4.60156C13.6667 5.01823 14.487 5.625 15.1328 6.42188C15.7839 7.21875 16.2682 8.18229 16.5859 9.3125C16.9036 10.4375 17.0625 11.7083 17.0625 13.125C17.0625 13.6094 16.9688 13.974 16.7812 14.2188C16.599 14.4688 16.3724 14.5938 16.1016 14.5938C15.8984 14.5938 15.7031 14.5495 15.5156 14.4609C15.3333 14.3724 15.1641 14.1875 15.0078 13.9062C14.5964 13.1354 14.1172 12.5208 13.5703 12.0625C13.0286 11.6042 12.3958 11.2734 11.6719 11.0703C10.9479 10.8672 10.1068 10.7656 9.14844 10.7656H8.95312V13.5859C8.95312 13.8828 8.85417 14.1302 8.65625 14.3281C8.45833 14.526 8.20833 14.625 7.90625 14.625Z"
                  fill="#A1A7B0"
                />
              </svg>
            </v-icon>

            <span style="font-size: 10px">Ответить</span>
          </v-row>
        </v-btn>

        <v-btn
          variant="text"
          size="small"
          class="mr-2"
          height="40"
          width="70"
          @click="
            $emit('update:newMail', false);
            $emit('update:fwd', true);
            $emit('update:sendModal', true);
          "
        >
          <v-row class="flex-column align-center">
            <v-icon class="mb-2"
              ><svg
                width="18"
                height="15"
                viewBox="0 0 18 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.0156 14.625C10.2188 14.625 10.4115 14.5807 10.5938 14.4922C10.7812 14.4089 10.9766 14.2708 11.1797 14.0781L17.3672 8.26562C17.5182 8.125 17.625 7.97396 17.6875 7.8125C17.7552 7.65104 17.7891 7.5 17.7891 7.35938C17.7891 7.21354 17.7552 7.0625 17.6875 6.90625C17.625 6.74479 17.5182 6.59375 17.3672 6.45312L11.1797 0.6875C10.9557 0.473958 10.7578 0.322917 10.5859 0.234375C10.4193 0.140625 10.2318 0.09375 10.0234 0.09375C9.71615 0.09375 9.46094 0.200521 9.25781 0.414062C9.0599 0.622396 8.96094 0.875 8.96094 1.17188V3.96875H8.76562C7.41146 3.96875 6.23698 4.17969 5.24219 4.60156C4.2526 5.01823 3.43229 5.625 2.78125 6.42188C2.13542 7.21875 1.65365 8.18229 1.33594 9.3125C1.01823 10.4375 0.859375 11.7083 0.859375 13.125C0.859375 13.6094 0.950521 13.974 1.13281 14.2188C1.32031 14.4688 1.54948 14.5938 1.82031 14.5938C2.02344 14.5938 2.21615 14.5495 2.39844 14.4609C2.58594 14.3724 2.75521 14.1875 2.90625 13.9062C3.31771 13.1354 3.79688 12.5208 4.34375 12.0625C4.89062 11.6042 5.52604 11.2734 6.25 11.0703C6.97396 10.8672 7.8125 10.7656 8.76562 10.7656H8.96094V13.5859C8.96094 13.8828 9.0599 14.1302 9.25781 14.3281C9.46094 14.526 9.71354 14.625 10.0156 14.625Z"
                  fill="#A1A7B0"
                />
              </svg>
            </v-icon>

            <span style="font-size: 10px">Переслать</span>
          </v-row>
        </v-btn>

        <v-btn
          variant="text"
          height="60"
          width="60"
          size="small"
          class="mr-2"
          @click="taskDialog = !taskDialog"
        >
          <v-row class="flex-column align-center">
            <v-icon class="mb-2"
              ><svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5 2.5C4.33696 2.5 3.70107 2.76339 3.23223 3.23223C2.76339 3.70107 2.5 4.33696 2.5 5V15C2.5 15.663 2.76339 16.2989 3.23223 16.7678C3.70107 17.2366 4.33696 17.5 5 17.5H15C15.663 17.5 16.2989 17.2366 16.7678 16.7678C17.2366 16.2989 17.5 15.663 17.5 15V5C17.5 4.33696 17.2366 3.70107 16.7678 3.23223C16.2989 2.76339 15.663 2.5 15 2.5H5ZM8.33333 6.66667C8.33333 6.44565 8.42113 6.23369 8.57741 6.07741C8.73369 5.92113 8.94565 5.83333 9.16667 5.83333H14.1667C14.3877 5.83333 14.5996 5.92113 14.7559 6.07741C14.9122 6.23369 15 6.44565 15 6.66667C15 6.88768 14.9122 7.09964 14.7559 7.25592C14.5996 7.4122 14.3877 7.5 14.1667 7.5H9.16667C8.94565 7.5 8.73369 7.4122 8.57741 7.25592C8.42113 7.09964 8.33333 6.88768 8.33333 6.66667ZM8.33333 10C8.33333 9.77899 8.42113 9.56702 8.57741 9.41074C8.73369 9.25446 8.94565 9.16667 9.16667 9.16667H14.1667C14.3877 9.16667 14.5996 9.25446 14.7559 9.41074C14.9122 9.56702 15 9.77899 15 10C15 10.221 14.9122 10.433 14.7559 10.5893C14.5996 10.7455 14.3877 10.8333 14.1667 10.8333H9.16667C8.94565 10.8333 8.73369 10.7455 8.57741 10.5893C8.42113 10.433 8.33333 10.221 8.33333 10ZM8.33333 13.3333C8.33333 13.1123 8.42113 12.9004 8.57741 12.7441C8.73369 12.5878 8.94565 12.5 9.16667 12.5H14.1667C14.3877 12.5 14.5996 12.5878 14.7559 12.7441C14.9122 12.9004 15 13.1123 15 13.3333C15 13.5543 14.9122 13.7663 14.7559 13.9226C14.5996 14.0789 14.3877 14.1667 14.1667 14.1667H9.16667C8.94565 14.1667 8.73369 14.0789 8.57741 13.9226C8.42113 13.7663 8.33333 13.5543 8.33333 13.3333ZM5.83333 5.83333C5.61232 5.83333 5.40036 5.92113 5.24408 6.07741C5.0878 6.23369 5 6.44565 5 6.66667C5 6.88768 5.0878 7.09964 5.24408 7.25592C5.40036 7.4122 5.61232 7.5 5.83333 7.5C6.05435 7.5 6.26714 7.4122 6.42342 7.25592C6.5797 7.09964 6.6675 6.88768 6.6675 6.66667C6.6675 6.44565 6.5797 6.23369 6.42342 6.07741C6.26714 5.92113 6.05435 5.83333 5.83333 5.83333ZM5 10C5 9.77899 5.0878 9.56702 5.24408 9.41074C5.40036 9.25446 5.61232 9.16667 5.83333 9.16667C6.05435 9.16667 6.26714 9.25446 6.42342 9.41074C6.5797 9.56702 6.6675 9.77899 6.6675 10C6.6675 10.221 6.5797 10.433 6.42342 10.5893C6.26714 10.7455 6.05518 10.8333 5.83417 10.8333C5.61315 10.8333 5.40036 10.7455 5.24408 10.5893C5.0878 10.433 5 10.221 5 10ZM5.83333 12.5C5.61232 12.5 5.40036 12.5878 5.24408 12.7441C5.0878 12.9004 5 13.1123 5 13.3333C5 13.5543 5.0878 13.7663 5.24408 13.9226C5.40036 14.0789 5.61232 14.1667 5.83333 14.1667C6.05435 14.1667 6.26714 14.0789 6.42342 13.9226C6.5797 13.7663 6.6675 13.5543 6.6675 13.3333C6.6675 13.1123 6.5797 12.9004 6.42342 12.7441C6.26714 12.5878 6.05435 12.5 5.83333 12.5Z"
                  fill="#A1A7B0"
                />
              </svg>
            </v-icon>

            <span style="font-size: 10px"
              >Создать <br />
              задачу</span
            >
          </v-row>
        </v-btn>
        <v-btn
          variant="text"
          height="60"
          width="60"
          size="small"
          class="mr-2"
          @click="getLink"
        >
          <v-row class="flex-column align-center">
            <v-icon class="mb-2"
              ><svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.17245 14.829L14.8294 9.17196M7.05045 11.293L5.63645 12.707C5.265 13.0784 4.97036 13.5194 4.76933 14.0047C4.56831 14.49 4.46484 15.0102 4.46484 15.5355C4.46484 16.0608 4.56831 16.5809 4.76933 17.0662C4.97036 17.5515 5.265 17.9925 5.63645 18.364C6.00789 18.7354 6.44886 19.03 6.93417 19.2311C7.41949 19.4321 7.93965 19.5356 8.46495 19.5356C8.99025 19.5356 9.51041 19.4321 9.99572 19.2311C10.481 19.03 10.922 18.7354 11.2934 18.364L12.7054 16.95M11.2924 7.04996L12.7064 5.63596C13.0779 5.26451 13.5189 4.96987 14.0042 4.76885C14.4895 4.56782 15.0096 4.46436 15.5349 4.46436C16.0602 4.46436 16.5804 4.56782 17.0657 4.76885C17.551 4.96987 17.992 5.26451 18.3634 5.63596C18.7349 6.0074 19.0295 6.44837 19.2306 6.93369C19.4316 7.419 19.535 7.93916 19.535 8.46446C19.535 8.98976 19.4316 9.50992 19.2306 9.99523C19.0295 10.4805 18.7349 10.9215 18.3634 11.293L16.9494 12.707"
                  stroke="#A1A7B0"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </v-icon>

            <span style="font-size: 10px"
              >Создать <br />
              ссылку</span
            >
          </v-row>
        </v-btn>
        <v-btn
          variant="text"
          height="40"
          width="60"
          size="small"
          @click="deleteMail"
        >
          <v-row class="flex-column align-center">
            <v-icon class="mb-2"
              ><svg
                width="16"
                height="19"
                viewBox="0 0 16 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.20312 18.1953H11.6016C12.1328 18.1953 12.5469 18.0547 12.8438 17.7734C13.1458 17.4974 13.3099 17.0964 13.3359 16.5703L13.8281 5.27344H14.9141C15.1068 5.27344 15.2708 5.20573 15.4062 5.07031C15.5417 4.9349 15.6094 4.77083 15.6094 4.57812C15.6094 4.38542 15.5417 4.22396 15.4062 4.09375C15.2708 3.96354 15.1068 3.89844 14.9141 3.89844H0.890625C0.697917 3.89844 0.533854 3.96615 0.398438 4.10156C0.263021 4.23177 0.195312 4.39062 0.195312 4.57812C0.195312 4.77083 0.263021 4.9349 0.398438 5.07031C0.533854 5.20573 0.697917 5.27344 0.890625 5.27344H1.98438L2.47656 16.5703C2.5026 17.0964 2.66406 17.4974 2.96094 17.7734C3.25781 18.0547 3.67188 18.1953 4.20312 18.1953ZM5.39844 15.8047C5.2474 15.8047 5.11979 15.7604 5.01562 15.6719C4.91667 15.5781 4.86719 15.4531 4.86719 15.2969L4.625 6.98438C4.625 6.82812 4.67188 6.70312 4.76562 6.60938C4.86458 6.51562 4.9974 6.46875 5.16406 6.46875C5.3151 6.46875 5.4401 6.51562 5.53906 6.60938C5.64323 6.70312 5.69792 6.82552 5.70312 6.97656L5.9375 15.2891C5.94271 15.4453 5.89583 15.5703 5.79688 15.6641C5.69792 15.7578 5.5651 15.8047 5.39844 15.8047ZM7.90625 15.8047C7.73958 15.8047 7.60417 15.7578 7.5 15.6641C7.40104 15.5703 7.35156 15.4479 7.35156 15.2969V6.97656C7.35156 6.82552 7.40104 6.70312 7.5 6.60938C7.60417 6.51562 7.73958 6.46875 7.90625 6.46875C8.06771 6.46875 8.19792 6.51562 8.29688 6.60938C8.40104 6.70312 8.45312 6.82552 8.45312 6.97656V15.2969C8.45312 15.4479 8.40104 15.5703 8.29688 15.6641C8.19792 15.7578 8.06771 15.8047 7.90625 15.8047ZM10.4062 15.8047C10.2396 15.8047 10.1068 15.7578 10.0078 15.6641C9.90885 15.5703 9.86198 15.4453 9.86719 15.2891L10.1016 6.97656C10.1068 6.82552 10.1589 6.70312 10.2578 6.60938C10.362 6.51562 10.4896 6.46875 10.6406 6.46875C10.8073 6.46875 10.9375 6.51562 11.0312 6.60938C11.1302 6.70312 11.1797 6.82812 11.1797 6.98438L10.9375 15.2969C10.9375 15.4531 10.8854 15.5781 10.7812 15.6719C10.6823 15.7604 10.5573 15.8047 10.4062 15.8047ZM4.27344 4.17188H5.88281V2.79688C5.88281 2.61979 5.9375 2.47917 6.04688 2.375C6.16146 2.26562 6.31771 2.21094 6.51562 2.21094H9.28125C9.47917 2.21094 9.63281 2.26562 9.74219 2.375C9.85677 2.47917 9.91406 2.61979 9.91406 2.79688V4.17188H11.5234V2.72656C11.5234 2.10677 11.3333 1.6224 10.9531 1.27344C10.5729 0.919271 10.0469 0.742188 9.375 0.742188H6.41406C5.74219 0.742188 5.21615 0.919271 4.83594 1.27344C4.46094 1.6224 4.27344 2.10677 4.27344 2.72656V4.17188Z"
                  fill="#A1A7B0"
                />
              </svg>
            </v-icon>

            <span style="font-size: 10px">Удалить</span>
          </v-row>
        </v-btn>
      </v-card>
    </v-row>
  </v-container>
</template>
<script>
import axios from "axios";
import copy from "copy-to-clipboard";
import { VDateInput } from "vuetify/labs/VDateInput";

export default {
  //TODO в открытом письме реализовать меню подробнее об отправителе
  //TODO реализовать интеграцию с битрикс(создание задачи)
  name: "Modal-component",
  props: {
    item: Object,
    modelValue: Boolean,
    index: Number,
  },
  components: {
    VDateInput,
  },
  emits: [
    "update:modal",
    "update:favorite",
    "update:sendModal",
    "update:newMail",
  ],
  data() {
    return {
      menu: false,
      taskDate: "",
      taskDialog: false,
      loading: false,
      dialogTask: false,
      urlCopy: "",
      isUrlCopy: false,
    };
  },
  methods: {
    fileDownload(file) {
      try {
        const byteCharacters = atob(file.base64); // Убираем возможный префикс "data:*"
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        // Создаем Blob с универсальным MIME-типом
        const blob = new Blob([byteArray], {
          type: "application/octet-stream",
        });

        // Создаем ссылку для скачивания
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = file.name;

        // Инициируем скачивание
        link.click();

        // Освобождаем память
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.log({ error });
      }
    },
    pause(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async getLink() {
      this.loading = true;
      let formData = new FormData();
      formData.append(`params`, "addMail");
      formData.append(`title`, this.item.subject);
      formData.append(`date`, `${this.item.dateTitle} ${this.item.timeTitle}`);
      formData.append(`text`, this.item.body);
      formData.append(`from_email`, this.item.from);
      formData.append(`from_name`, this.item.fromName);
      formData.append(`to_email`, this.item.to);
      for (const fileIndex in this.item.files) {
        const jsonData = JSON.stringify(this.item.files[fileIndex]);
        formData.append(`file[${fileIndex}]`, jsonData);
      }

      const id = await axios.post("https://email.rcgit.ru/db/", formData);
      console.log({ id });
      let url = `https://spa-bitrix.ru/mail/?id=${id.data}`;
      //  console.log({ url });
      const clickru = await axios.get("https://clck.ru/--", {
        params: { url },
      });
      console.log({ clickru });
      const saveUrl = clickru.data;
      this.urlCopy = saveUrl;
      //const isUrlCopy = await window.navigator.clipboard.writeText(saveUrl);
      //console.log({ isUrlCopy });
      copy(this.urlCopy);
      this.isUrlCopy = true;
      //console.log({ saveUrl });
      if (this.$store.state.isMobile) {
        alert("Ссылка на письмо скопирована!");
      }
      this.loading = false;
    },
    async taskAdd() {
      try {
        //
      } catch (error) {
        console.log(error);
      }
    },
    swipe() {
      this.$emit("update:modal", false);
    },
    async deleteMail() {
      try {
        console.log("delete");
        let formData = new FormData();
        formData.append(`params`, "deleteMessage");
        formData.append(`login`, this.$store.state.mailbox[this.index].title);
        formData.append(`password`, this.$store.state.mailbox[this.index].pass);
        formData.append(
          `host`,
          this.$store.state.settings[
            this.$store.state.mailbox[this.index].server
          ].imap.address
        );
        formData.append(
          `port`,
          this.$store.state.settings[
            this.$store.state.mailbox[this.index].server
          ].imap.port
        );
        formData.append(`encrypt`, "ssl");
        formData.append(
          `type`,
          this.$store.state.mailbox[this.index].pass ? "password" : "oauth"
        );
        formData.append(`folder_number`, this.item.folderId);
        formData.append(`id`, this.item.id);

        //получить все письма по каждой из папки
        await axios.post("https://email.rcgit.ru/imap/", formData);

        this.$emit("deleteMail", this.item);

        this.$emit("update:modal", false);
      } catch (error) {
        console.log({ error });
      }
    },
  },
};
</script>
<style scoped>
.displaynone {
  display: none;
}
</style>
